module.exports = __webpack_public_path__ + "img/gls-cod.2ce42332.png";